import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { destFor } from "@/lib/roles";

export const POST_LOGIN_KEY = "post_login_dest";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const dest = sessionStorage.getItem(POST_LOGIN_KEY) || "";
    sessionStorage.removeItem(POST_LOGIN_KEY);
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate(destFor(data, dest), { replace: true });
      })
      .catch((e) => {
        setUser(false);
        navigate("/login", { replace: true, state: { error: errMsg(e) } });
      });
  }, [location.hash, navigate, setUser]);

  return <div className="flex h-screen items-center justify-center text-slate-500" data-testid="auth-callback">Memproses login Google...</div>;
};
